import { overrides } from './environment.development';
import { ENVIRONMENT_DEFAULTS, Environment } from './environment.model';

export const environment: Environment = {
  ...ENVIRONMENT_DEFAULTS,

  icmChannel: 'inSPIRED-inTRONICS_Business-Site',
  //icmBaseURL: 'https://localhost:8443',
  //icmBaseURL: 'https://10.3.1.44:8443',
  //icmBaseURL: 'https://pwa-public-demo.test.intershop.com',
  //icmBaseURL: 'https://pwa-ish-demo.test.intershop.com',
  icmBaseURL: 'https://dssdias-sit.intershop.cloud',
  themeColor: '#12c1db',
  icmApplication: '-',
  hybridApplication: 'smb-responsive',

  features: [
    ...ENVIRONMENT_DEFAULTS.features,
    'businessCustomerRegistration',
    'costCenters',
    'maps',
    'punchout',
    'quickorder',
    'quoting',
    'orderTemplates',
    'guestCheckout',
    'tracking',
    /* ICSA Features */
    'customQuickorder',
    'saveForLater',
    'onePageCheckout',
    'multipleShippingCheckout',
    'salesRep',
    'bulkOrder',
    'extraConfiguration',
    'dotCmsUve',
  ],
  productListingItemsPerPage: {
    category: 12,
    search: 12,
    master: 6,
  },
  defaultProductListingViewType: 'grid',

  /* identityProvider: 'Punchout',
  identityProviders: {
    Punchout: {
      type: 'PUNCHOUT',
    },
  }, */
  ...overrides,
};
